import React, { useContext, useState } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import Modal from '../ui/Modal';
import SvgButton from '../ui/SvgButton';

interface GamePaperMakingHintsAndDescriptionModalProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  lives: number,
}

function GamePaperMakingHintsAndDescriptionModal(props: GamePaperMakingHintsAndDescriptionModalProps) {
  const { playClick } = useContext(AudioContext);
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <div className="lives-and-hints">
        <div className="lives-and-hints-counter-wrapper">
          <div className={`lives-and-hints-counter${props.lives > 2 ? '' : ' lives-and-hints-counter-used'}`}></div>
          <div className={`lives-and-hints-counter${props.lives > 1 ? '' : ' lives-and-hints-counter-used'}`}></div>
          <div className={`lives-and-hints-counter${props.lives > 0 ? '' : ' lives-and-hints-counter-used'}`}></div>
        </div>

        <button className="hints-button" onClick={() => { playClick(); setModalShow(true) }}>  </button>
        {modalShow
          ? <Modal>
            <div className="modal modal-game-paper-making game-description">
              <button className="button modal-button-close" onClick={() => { playClick(); setModalShow(false) }}>
                <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-paper-making/close-button`} src1=".svg" src2="-select.svg" alt="關閉"></SvgButton>
              </button>
              <div className="modal-content">
                <div className="bullet"><span className="order">1.</span><span>顯示一次造紙術次序後進入遊戲</span></div>
                <div className="bullet"><span className="order">2.</span><span>畫面顯示六個動作</span></div>
                <div className="bullet"><span className="order">3.</span><span>玩家依正確次序選擇動作</span></div>
                <div className="bullet"><span className="order">4.</span><span>挑戰一分鐘內完成張數</span></div>
              </div>
            </div>
          </Modal>
          : null}
      </div>
    </>
  );
}

export default GamePaperMakingHintsAndDescriptionModal;
